import { EstimateModel } from "./estimate.model";
import { LeadModel } from "./lead.model";
import { PurchaseModel } from "./purchase.model";
import { SalesModel } from "./sales.model";
import * as yup from "yup";

export enum ContacTypes {
    CUSTOMER = "Customer",
    VENDOR = "Vendor",
    CONTRACTOR = "Contractor",
    BROKER = "Broker",
    LEAD = "Lead", // (add new type)
    BUYER = "Buyer",
    SELLER = "Seller",
    BUYER_SALLER = "Buyer/Seller",
    INVESTOR = "Investor",
    AGENT = "Agent",
    OTHER = "Other"
}

export interface ContactModel {
    id: number | null;
    name: string | null;//Name
    contactType: ContacTypes | null;
    mobileNo: string | null;//Mobile No
    emailId: string | null;//Email Id
    businessName: string | null;//Company/Business Name
    businessType: string | null;//Business Type
    alternateMobileNo: string | null;//Alternate Mobile No
    phoneNo: string | null;//Phone No
    contactOn: string | null;//Contact on(Mobile No or Phone no dropdown)
    fax: string | null;//Fax
    website: string | null;//Website
    birthDate: string | null;//Birth Date
    marriageDate: string | null;//Marriage Date
    socialMediaAccountLinks: string | null;//Social media account links
    sameAddress: boolean | null;//Address Same as Magnet App(In detail)
    address: string | null;//Address Same as Magnet App(In detail)
    sourceOfPromotion: string | null//Source of promotion(Dropdown + Add new promotion type manually)
    sourceCampaign: string | null;//Source Campaign(Dropdown)
    descriptionInformation: string | null;//Description Information
    created_by?: number | null;
    updated_by?: number | null;
    created_at: Date | null;
    updated_at: Date | null;
    estimates: EstimateModel[] | null;
    sales: SalesModel[] | null;
    purchases: PurchaseModel[] | null;
    leads: LeadModel[] | null;
}

export class ContactClass implements ContactModel {
    id = null;
    name = String()
    contactType: any = String();
    mobileNo:any = null;//Mobile No
    emailId = null;//Email Id
    businessName = null;//Company/Business Name
    businessType = null;//Business Type
    alternateMobileNo = null;//Alternate Mobile No
    phoneNo = null;//Phone No
    contactOn = null;//Contact on(Mobile No or Phone no dropdown)
    fax = null;//Fax
    website = null;//Website
    birthDate = null;//Birth Date
    marriageDate = null;//Marriage Date
    socialMediaAccountLinks = null;//Social media account links
    address = null;
    sameAddress = null;//Address Same as Magnet App(In detail)
    sourceOfPromotion: any = String() //Source of promotion(Dropdown + Add new promotion type manually)
    sourceCampaign = null;//Source Campaign(Dropdown)
    descriptionInformation = String();//Description Information
    created_by?= null;
    updated_by?= null;
    created_at = null;
    updated_at = null;
    estimates = null;
    sales = null;
    purchases = null;
    leads = null;
}

// validationSchema
export const ContactValidationSchema = {
    name: yup.string().required("Name is required").nullable(), 
    contactType: yup.string().required("ContactType is required").nullable(),
    mobileNo: yup.number().required("MobileNo. is required").nullable(),
    phoneNo: yup.number().required("phoneNo. is required").nullable(),
    sourceOfPromotion: yup.string().required("Source Of Promotion is required").nullable()
}